export const ADENGI_COMPANY_NAME = 'Реклама ООО МКК «А ДЕНЬГИ» ИНН: 7708400979';
export const ADENGI_URL = 'https://eye.targetads.io/view/click?pid=12781&cn=16555&pl=49735';
export const ADENGI_TITLE = 'Оценивайте свои финансовые возможности и риски';
